const axios = require('axios').default;
const axiosRetry = require('axios-retry');
axiosRetry(axios, {
    retries: 3, // number of retries
    retryDelay: (retryCount) => {
        console.log(`retry attempt: ${retryCount}`);
        return retryCount * 300; // time interval between retries
    },
    retryCondition: (error) => {
        // if retry condition is not specified, by default idempotent requests are retried
        return !(error && error.response && error.response.status === 400);
    },
});

const RESOURCE_NAME = process.env.REACT_APP_API_BASE + '/authentication';
const headers = {
    'Content-Type': 'application/json',
};

export default {
    async checkAuthentication(uuid, phoneNumber, app_id) {
        const body = {
            "uuid": uuid,
            "phoneNumber": phoneNumber,
            "app_id": app_id
        };
        const requestOptions = {
            headers: headers,
        };
        return await axios.post(RESOURCE_NAME, JSON.stringify(body), requestOptions);
    },
}
